<div>

  <div style="margin-bottom:10px; text-align:right;">
    <button mat-raised-button color="primary" (click)="printPageA4()">Print</button>
    <button mat-raised-button color="primary" (click)="exportExcel('officewise_report')">Export</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>

  <div id="print-section">

    <table border="1" style="width:100%; border-collapse: collapse;">

     
     <tr>
  <th colspan="8"
      style="text-align:center;
             background:#d9e7ff;
             font-size:20px;
             font-weight:bold;">

    Office Representative Report

  </th>
</tr>

        <tr style="font-size:16px; font-weight:bold; background:#f2f2f2;">
  <th>Sr</th>
  <th>Seller</th>
  <th>Taluka</th>
  <th>District</th>
  <th>Rep</th>
  <th>Copies</th>
  <th>Mobile</th>
  <th>Distributive Mode</th>
</tr>
      

      <tbody>

        <ng-container *ngFor="let office of sellerData">

          <tr>
            <td colspan="8" style="background:#d9e7ff; font-weight:bold; color:red;text-align:center;">
              Office Rep: {{ office.office_rep_name }}
            </td>
          </tr>

          <tr *ngFor="let item of office.data; let i = index">

            <td>{{ i + 1 }}</td>
            <td>{{ safeText(item.name) }}</td>
            <td>{{ safeText(item.taluka) }}</td>
            <td>{{ safeText(item.district) }}</td>
            <td>{{ safeText(item.rep_name) }}</td>
            <td>{{ item.total_book_copies ?? 0 }}</td>
            <td>{{ safeText(item.mobile_no) }}</td>
            <td>{{ safeText(item.dis_mode) }}</td>

          </tr>

          <tr style="font-weight:bold; background:#f0f0f0;">
            <td colspan="5" style="text-align:center;">
              Group Total
            </td>
            <td>{{ office.group_total_book_copies }}</td>
            <td colspan="2">Records: {{ office.data.length }}</td>
          </tr>

        </ng-container>

        <tr style="font-weight:bold; background:#d9e7ff;">
          <td colspan="5" style="text-align:right;">Grand Total</td>
          <td>{{ overallTotalBookCopies }}</td>
          <td colspan="2">Records: {{ getGrandTotalRecords() }}</td>
        </tr>

      </tbody>

    </table>

  </div>
</div>  